import {
    SET_PROGRESS_BAR,
    SET_NAVIGATION_DRAWER
} from "../actions/actionTypes";

const DEFAULT_STATE = {
  progressBarStatus: Boolean(false),
  navigationDrawerStatus: Boolean(false)
};

export default (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SET_PROGRESS_BAR:
      return {...state, progressBarStatus: action.payload};
    case SET_NAVIGATION_DRAWER:
      return {...state, navigationDrawerStatus: action.payload};
    default:
      return state;
  }
}